import { render } from "./pca-dictionary-virtual-grid.vue?vue&type=template&id=2341758c"
import script from "./pca-dictionary-virtual-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-dictionary-virtual-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-dictionary-virtual-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2341758c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2341758c', __exports__)) {
    api.reload('2341758c', __exports__)
  }
  
  module.hot.accept("./pca-dictionary-virtual-grid.vue?vue&type=template&id=2341758c", () => {
    api.rerender('2341758c', render)
  })

}


export default __exports__